import { getVijilization } from "services/project";
import { WalkthroughWithRoute } from "utils/walkthroughs";

// The public, read-only demo project every guided walkthrough runs on. Configured
// per environment (demo vs app) at build time.
export const PUBLIC_WALKTHROUGH_PROJECT_ID =
  process.env.REACT_APP_PUBLIC_WALKTHROUGH_PROJECT_ID || "";

// True when the given project id is the public, read-only demo project. Used to
// gray out mutating actions (rename/delete project, run/delete vijilization).
export const isPublicWalkthroughProject = (
  projectId?: string | null
): boolean =>
  !!PUBLIC_WALKTHROUGH_PROJECT_ID &&
  String(projectId) === PUBLIC_WALKTHROUGH_PROJECT_ID;

// Resolve a context-needing walkthrough to a concrete, shareable URL on the given
// (public) project. For vijilize-scoped tours it picks the project's first
// completed run. Returns null when the tour needs a run and none exists.
export async function resolveWalkthroughUrl(
  w: WalkthroughWithRoute,
  projectId: string
): Promise<string | null> {
  const query = new URLSearchParams();

  if (w.route.includes(":vijilizeId")) {
    const vijRes: any = await getVijilization(projectId, "");
    const runs: any[] = Array.isArray(vijRes?.data) ? vijRes.data : [];
    const run = runs.find((r) => r.status === "completed") || runs[0];
    const vijilizeId = run?._id || "";
    if (!vijilizeId) return null;
    const path = w.route
      .replace(":id", projectId)
      .replace(":vijilizeId", vijilizeId);
    query.set("walkthrough", w.id);
    return `${path}?${query.toString()}`;
  }

  // Project-scoped tours (Comparison Library / Vijilizations tab): pin the sub-tab
  // so the anchored elements are on screen.
  if (w.route.endsWith("find-covered-product")) {
    query.set(
      "tab",
      w.id === "review-vijilizations-tab" ? "vijilizations" : "comparison-library"
    );
  }
  query.set("walkthrough", w.id);
  return `${w.route.replace(":id", projectId)}?${query.toString()}`;
}
